import styled from '@emotion/styled';
import { boxShadowMixins } from '@styles/mixins';
import { withTheme } from '@emotion/react';
import React from 'react';
import { TestId } from '@components/test-ids';
import { HelpCentreLink } from '@components/common/next-link';
import { Page } from '@model/common';
import { HelpCategoryListItem } from '@model/iceberg/help-centre';
import { getPathFromName } from '@util/path';
import { ThemeProps } from '@theme/base';

export interface InfoTileProps {
  testId?: string;
  tile: HelpCategoryListItem;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  borderRadius: 3,
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.custom.colors.white,
  padding: theme.custom.spacing.xLarge,
  boxShadow: boxShadowMixins(theme.custom.colors.group10.base).default,
  border: `1px solid ${theme.custom.colors.group10.light}`,
  height: '100%',
  cursor: 'pointer',
  transition: `border ${theme.custom.transitions.default}, box-shadow ${theme.custom.transitions.default}`,
  ':hover': {
    border: `1px solid ${theme.custom.states.hover.dark}`,
    boxShadow: boxShadowMixins(theme.custom.states.hover.light).default
  }
}));

const Title = styled.h5(({ theme }: ThemeProps) => ({
  margin: '10px 0',
  ...(theme.custom.typography.h4 as any),
  color: theme.custom.colors.group4.base
}));

const Description = styled.p(({ theme }: ThemeProps) => ({
  margin: 0,
  ...(theme.custom.typography.paragraph as any),
  color: theme.custom.colors.group4.base
}));

export const InfoTileComponent = (props: InfoTileProps) => {
  const {
    tile: { title, description }
  } = props;
  const url = getPathFromName(title);
  return (
    <HelpCentreLink path={Page.HELP_CENTRE.concat('/').concat(url)}>
      <Container data-testid={props.testId || TestId.infoTile.main}>
        <div>
          <Title data-testid={TestId.infoTile.title}>{title}</Title>
          <Description data-testid={TestId.infoTile.description}>{description}</Description>
        </div>
      </Container>
    </HelpCentreLink>
  );
};

export const HelpCentreInfoTile = withTheme(InfoTileComponent);
